import { render, staticRenderFns } from "./DatosAbono.vue?vue&type=template&id=b15500d6"
import script from "./DatosAbono.vue?vue&type=script&lang=js"
export * from "./DatosAbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports